import { render, staticRenderFns } from "./fcost.vue?vue&type=template&id=0ec463b7&scoped=true&"
import script from "./fcost.vue?vue&type=script&lang=js&"
export * from "./fcost.vue?vue&type=script&lang=js&"
import style0 from "./fcost.vue?vue&type=style&index=0&id=0ec463b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec463b7",
  null
  
)

export default component.exports